import { maxTablet, maxWidth, retina } from 'Utils/utilsStyle';
import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 48px;
  width: 48px;
  border: 3px solid #DADADA;
  border-radius: 50%;
  @media all and (max-width: ${maxWidth}), ${retina} {
    height: 38px;
    width: 38px;
  }
  @media all and (max-width: ${maxTablet}) {
    height: 36px;
    width: 36px;
  }
  .company-card-img {
    width: inherit;
    height: inherit;
    border-radius: inherit;
    padding: 8px;
  }
`;

type Props = {
  logo: string
};
const CompanyDocumentCard = function CompanyDocumentCard(props: Props) {
  const { logo } = props;
  return (
    <Wrapper className="company-document-card">
      <img src={logo} alt="company-card-img" className="company-card-img" />
    </Wrapper>
  );
};
export default CompanyDocumentCard;
